export class NewHabitDto {
  habitDictionaryId: number;
  constructor(habitDictionaryId: number) {
    this.habitDictionaryId = habitDictionaryId;
  }
}
